'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Toggle = require('components/Toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showOverlay = function showOverlay() {
  var selector = _Dom2.default.overlay;
  var action = 'add';
  var animated = true;

  return (0, _Toggle.toggleElement)({ selector: selector, action: action, animated: animated });
};

var hideOverlay = function hideOverlay() {
  var selector = _Dom2.default.overlay;
  var action = 'remove';
  var animated = true;

  return (0, _Toggle.toggleElement)({ selector: selector, action: action, animated: animated });
};

var toggleOverlay = function toggleOverlay(data) {
  var overlayActive = $(_Dom2.default.overlay).is(_Dom2.default.isActive);

  return overlayActive ? hideOverlay(data) : showOverlay(data);
};

exports.default = {
  show: showOverlay,
  hide: hideOverlay,
  toggle: toggleOverlay
};